import { Card, EmptyState } from "../common";
import useAsync from "../../hooks/useAsync";
import { getMyKraKpiTree } from "../../services/kraKpiProposalApi";
import { sortAlpha } from "../../utils/alphaSort"; // [NEW] A to Z

export default function KraKpiTreeCard({ cycleId, version = 0 }) {
  const tree = useAsync(() => getMyKraKpiTree(cycleId), [cycleId, version], { skip: !cycleId });
  const data = tree.data;
  if (tree.error || !data) return null;
  if (!data.kras.length && !data.unmapped.length) return null;
  return (
    <Card title="KRA → KPI map" subtitle="Your KRAs with the KPIs that measure them (from the KRA/KPI library mapping).">
      {data.kras.length === 0 && <EmptyState compact title="No KRAs yet" />}
      <ul className="icon-list kra-tree">
        {sortAlpha(data.kras).map((kra) => (
          <li key={kra.id}>
            <strong>{kra.name}</strong> <span className="muted">({kra.weightage}% of KRAs)</span>
            {kra.kpis.length > 0 ? (
              <ul className="icon-list">
                {sortAlpha(kra.kpis).map((kpi) => <li key={kpi.id}>{kpi.name} <span className="muted">— target {kpi.target} {kpi.unit}</span></li>)}
              </ul>
            ) : <div className="muted">No KPI on your sheet measures this KRA yet.</div>}
          </li>
        ))}
        {data.unmapped.length > 0 && (
          <li>
            <strong>KPIs not linked to a KRA</strong>
            <ul className="icon-list">{sortAlpha(data.unmapped).map((kpi) => <li key={kpi.id}>{kpi.name}</li>)}</ul>
          </li>
        )}
      </ul>
    </Card>
  );
}
